import script from "./video-PC.vue?vue&type=script&setup=true&lang=js"
export * from "./video-PC.vue?vue&type=script&setup=true&lang=js"

import "./video-PC.vue?vue&type=style&index=0&id=12376576&lang=less&scoped=true"

import exportComponent from "D:\\code\\saicDesign_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12376576"]])

export default __exports__